import { tosMeta } from "@constants/legal";
import { useAppStore } from "@hooks/useAppStore";
import LegalView from "components/LegalView";

const TermsRoute = () => {
	const appName = useAppStore((store) => store.app.name);
	const baseUrl = useAppStore((store) => store.app.links.baseUrl);
	const supportEmail = useAppStore((store) => store.supportEmail);

	const processedText = tosMeta.tos
		.replace(/\{\{appNameUpper\}\}/g, appName.toUpperCase())
		.replace(/\{\{appName\}\}/g, appName)
		.replace(/\{\{baseUrl\}\}/g, baseUrl || "memorang.com")
		.replace(
			/\{\{supportEmail\}\}/g,
			supportEmail || "support@mail.memorang.com",
		);

	return (
		<LegalView
			dates={tosMeta.dates}
			text={processedText}
			title={tosMeta.title}
		/>
	);
};

export default TermsRoute;
